import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import localSave from '../utils/localSave'

interface LoginState {
  isLogin: boolean
  avatar: string
}

const defaultLoginState:LoginState = {
  isLogin: !!localSave.read('token'),
  avatar: localSave.read('avatar')
}

const loginState = atom<LoginState>({
  key: 'loginState',
  default: defaultLoginState
})

export const useLoginState = ()=>useRecoilState(loginState)
export const useLoginValue = ()=>useRecoilValue(loginState)
export const useSetLoginState = ()=>useSetRecoilState(loginState)
